const productCalculator = {

    ui: {},

    init: function() {
        // console.log('product-calculator');

        this.bindUI();
        this.bindEvents();
    },

    bindUI: function() {
        // this.ui.$document = $(document);
        //
        // this.ui.$form = $(".js-product-calculator");

        this.ui.form = document.querySelector(".js-product-calculator");
        this.ui.wallList = document.querySelector('.js-product-calculator-wall-list');
        this.ui.unit = document.querySelector('.js-product-calculator-unit');
    },

    bindEvents: function() {
        this.addEventListenerOnList(this.ui.form.querySelectorAll('.js-product-calculator-wall-input'), 'change', this.computeWall.bind(this));
        this.ui.form.querySelector('.js-product-calculator-wall-add').addEventListener('click', this.newWall.bind(this));
        this.ui.form.querySelector('.js-product-calculator-wall-remove').addEventListener('click', this.removeWall.bind(this));
        // this.ui.form.querySelector('.js-product-calculator-refresh').addEventListener('click', this.refresh.bind(this));
        this.ui.form.addEventListener('submit', this.calculate.bind(this));
        this.addEventListenerOnList(this.ui.unit.querySelectorAll('input'), 'change', this.changeUnit.bind(this));
    },

    addEventListenerOnList(nodeListOfElements, type, fun) {
        for (let i = 0; i < nodeListOfElements.length; i++) {
            nodeListOfElements[i].addEventListener(type, fun);
        }
    },

    is: function(el, selector) {
        return (el.matches || el.matchesSelector).call(el, selector);
    },

    parents: function(element, selector) {
        let parentNode = element.parentNode;
        if(document === parentNode) {
            return null;
        } else if(this.is(parentNode, selector)) {
            return parentNode;
        }
        return this.parents(parentNode, selector);
    },

    closest: function(element, selector) {
        if(this.is(element, selector)) {
            return element;
        }
        return this.parents(element, selector);
    },

    computeWall: function(e) {
        let wall = this.closest(e.currentTarget, '.js-product-calculator-wall');
        let height = wall.querySelector('.js-product-calculator-wall-height').value;
        let width = wall.querySelector('.js-product-calculator-wall-width').value;
        //divide by 10000.0 to go from cm2 to m2
        wall.querySelector('.js-product-calculator-wall-surface-meter input').value = (height * width) / 10000.0;
        //divide by 36*36 to go from inch2 to yard2
        wall.querySelector('.js-product-calculator-wall-surface-yard input').value = (height * width) / (36.0 * 36);
    },

    newWall: function(e) {
        let prototype = e.currentTarget.dataset.prototype;
        let el = document.createElement('DIV');
        el.innerHTML = prototype;
        this.addEventListenerOnList(el.querySelectorAll('.js-product-calculator-wall-input'), 'change', this.computeWall.bind(this));
        el.querySelector('.js-product-calculator-wall-remove').addEventListener('click', this.removeWall.bind(this));
        this.ui.wallList.appendChild(el.firstChild);
        this.changeUnit();
    },

    removeWall: function(e) {
        let el = this.closest(e.currentTarget, '.js-product-calculator-wall');
        if (null !== el && null !== el.parentNode) {
            el.parentNode.removeChild(el);
        }
    },

    // refresh: function(e) {
    //     let form = this.closest(e.currentTarget, ".js-product-calculator");
    //     form.querySelectorAll('.js-product-calculator-wall-input').forEach(el => {
    //         el.value = '';
    //     });
    //     form.querySelectorAll('.js-product-calculator-wall-surface-meter input').forEach(el => {
    //         el.value = 0;
    //     });
    //     form.querySelectorAll('.js-product-calculator-wall-surface-yard input').forEach(el => {
    //         el.value = 0;
    //     });
    // },

    // calculate: function(e) {
    //     e.preventDefault();
    //     let walls = this.ui.form.querySelectorAll('.js-product-calculator-wall');
    //     let surface = 0;
    //     walls.forEach(wall => {
    //         let height = wall.querySelector('.js-product-calculator-wall-height').value;
    //         let width = wall.querySelector('.js-product-calculator-wall-width').value;
    //         surface += height*width;
    //     });
    //     //console.log(surface);
    //     let calculateBtn = this.ui.form.querySelector('.js-product-calculator-calculate');
    //     let rollWidth = calculateBtn.dataset.width;//cm
    //     let rollLength = Math.round(calculateBtn.dataset.length * 100);//meter
    //     let rollSurface = Math.round(rollWidth * rollLength);//cm2
    //
    //     let count = surface / rollSurface;
    //     let meters = Math.ceil(rollLength * count / 100);
    //     let rolls = this.ui.form.querySelector('.js-product-calculator-result-rolls');
    //     rolls.value = Math.ceil(count);
    //     let result = this.ui.form.querySelector('.js-product-calculator-result-meters');
    //     result.value = meters;
    // },

    calculate: function(e) {
        e.preventDefault();
        let $walls = this.ui.form.querySelectorAll('.js-product-calculator-wall');
        let $rollerInput = this.ui.form.querySelector('.js-product-calculator-result-rolls');
        let $meterInput = this.ui.form.querySelector('.js-product-calculator-result-meters');

        let calculateBtn = this.ui.form.querySelector('.js-product-calculator-calculate');
        //let currentUnit = document.querySelector('.js-calculator-unit input[name="unit"]:checked').getAttribute('data-unit');
        let wppVerticalRepeat = parseFloat(calculateBtn.dataset.vertical);
        let wppLaize = parseFloat(calculateBtn.dataset.width);
        let wppSaleUnit = parseFloat(calculateBtn.dataset.length) * 100;

        let wallResult = [];
        for(var i =0; i < $walls.length; i++){
            let wallHeight = $walls[i].querySelector('.js-product-calculator-wall-height').value;
            let wallWidth = $walls[i].querySelector('.js-product-calculator-wall-width').value;
            if(wallHeight !== '' && wallHeight !== null && wallWidth !== '' && wallWidth !== null){
                wallHeight = parseFloat(wallHeight);
                wallWidth = parseFloat(wallWidth);
                if(this.ui.unit.querySelector('input:checked').value !== "CM") {//conv inch to cm
                    wallHeight *= 2.54;
                    wallWidth *= 2.54;
                }
                if(wppSaleUnit == 1){
                    wallResult[i] = (Math.ceil( (wallHeight + 20) / wppVerticalRepeat) * wppVerticalRepeat ) * Math.ceil( wallWidth / wppLaize ) / wppSaleUnit;
                }else{
                    wallResult[i] = Math.ceil( (Math.ceil( (wallHeight + 20) / wppVerticalRepeat) * wppVerticalRepeat ) * Math.ceil( wallWidth / wppLaize ) / wppSaleUnit );
                }
            }
        }
        const reducer = (accumulator, currentValue) => accumulator + currentValue;
        let finalResult = wallResult.reduce(reducer);
        $meterInput.value = finalResult;
        $rollerInput.value = Math.ceil(finalResult);
    },

    changeUnit: function() {
        let unit = this.ui.unit.querySelector('input:checked');
        if("CM" === unit.value) {
            this.ui.wallList.querySelectorAll('.js-product-calculator-wall-surface-meter').forEach(el => el.style.display = "block");
            this.ui.wallList.querySelectorAll('.js-product-calculator-wall-surface-yard').forEach(el => el.style.display = "none");
        } else {
            this.ui.wallList.querySelectorAll('.js-product-calculator-wall-surface-meter').forEach(el => el.style.display = "none");
            this.ui.wallList.querySelectorAll('.js-product-calculator-wall-surface-yard').forEach(el => el.style.display = "block");
        }
    }
};

module.exports = productCalculator;
